import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ChangePasswordModalComponent } from "../../common-dialog-management/changepassword/change-password-dialog.component";

@Component({
  selector: "app-color-modal",
  templateUrl: "./color-modal.component.html",
  styleUrls: ["./color-modal.component.scss"],
})
export class ColorModalComponent implements OnInit {
  primary: string = "#8370FF";
  Data: any;
  constructor(
    public dialogRef: MatDialogRef<ChangePasswordModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.Data = data;
    this.primary = this.Data.color;
    // console.log(this.Data);
  }

  ngOnInit() {}

  handlePrimaryColorChange(e) {
    this.primary = e.color.hex;
  }

  onSubmit() {
    // console.log(this.primary);
    this.dialogRef.close(`${this.primary} ${this.Data.type}`);
  }
}
